
import { AuthContext } from "../../Context"
import { useNavigate } from 'react-router-dom'
import { AuthContextApi } from "../../Context/api"
import { useContext, useEffect, useState } from "react"
import Footer from "../../Components/Footer"
import { jsonConfig } from "../../Config"
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid'
import './index.css'


const Login = () => {

    const { states, setters } = useContext(AuthContext)
    const { login, forgotPass } = useContext(AuthContextApi)
    const navigate = useNavigate()

    const [errorEmail, setErrorEmail] = useState(false)
    const [msgErrorEmail, setMsgErrorEmail] = useState('O campo email é obrigatório')
    const [errorSenha, setErrorSenha] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [remainSigned, setRemainSigned] = useState(false)
    const [perdeuSenha, setPerdeuSenha] = useState(false)

    const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email)

    const actionLogin = async () => {
        if (!perdeuSenha) {
            let error;
            if (states.email === '') {
                setErrorEmail(true)
                error = true;
            } else {
                if (!isValidEmail(states.email)) {
                    setErrorEmail(true)
                    setMsgErrorEmail('Insira um e-mail válido')
                    error = true;
                } else {
                    setMsgErrorEmail('O campo email é obrigatório')
                    setErrorEmail(false)
                }
            }
            if (states.senha === '') {
                setErrorSenha(true)
                error = true;
            } else {
                setErrorSenha(false)
            }
            if (error) { error = false; return }
            if (remainSigned) {
                localStorage.setItem('userEmail', states.email)
                localStorage.setItem('userPassword', states.senha)
            }
            const response = await login({ email: states.email, senha: states.senha })
            if (response) navigate('/dashboard')
        } else {
            let error;
            if (states.email === '') {
                setErrorEmail(true)
                error = true;
            } else {
                if (!isValidEmail(states.email)) {
                    setErrorEmail(true)
                    setMsgErrorEmail('Insira um e-mail válido')
                    error = true;
                } else {
                    setMsgErrorEmail('O campo email é obrigatório')
                    setErrorEmail(false)
                }
            }
            if (error) { error = false; return }
            const resp = await forgotPass({ email: states.email })
            const resetModal = () => () => {
                setters.setModalMsg(false)
                setErrorEmail(false)
                setErrorSenha(false)
                setters.setEmail('')
                setters.setSenha('')
                localStorage.removeItem('userEmail')
                localStorage.removeItem('userPassword')
                setPerdeuSenha(false)
            }
            if (resp) {
                setters.setModalMsg(true)
                setters.setMsgModalMsg('Recuperação de senha')
                setters.setDescModalMsg('Recuperação de senha enviada com sucesso! Verifique seu e-mail.')
                setters.setPerigoModalMsg(false)
                setters.setTitleButtonModalMsg('Retornar para login')
                setters.setFunctionModalMsg(resetModal)
            } else {
                setters.setModalMsg(true)
                setters.setMsgModalMsg('Recuperação de senha')
                setters.setDescModalMsg('Parece que ocorreu um erro! Tente novamente mais tarde.')
                setters.setPerigoModalMsg(true)
                setters.setTitleButtonModalMsg('Retornar')
                setters.setFunctionModalMsg(resetModal)
            }
        }
    }

    const remindSignedAction = (data) => {
        setRemainSigned(data)
        if (data === false) {
            localStorage.removeItem('userEmail')
            localStorage.removeItem('userPassword')
        } else {
            localStorage.setItem('userEmail', states.email)
            localStorage.setItem('userPassword', states.senha)
        }
    }

    const perdeuSenhaAction = () => {
        setPerdeuSenha(true)
        setErrorEmail(false)
        setErrorSenha(false)
        setters.setEmail('')
        setters.setSenha('')
        localStorage.removeItem('userEmail')
        localStorage.removeItem('userPassword')
    }

    const voltarLogin = () => {
        setPerdeuSenha(false)
        setErrorEmail(false)
        setErrorSenha(false)
        setters.setEmail('')
        setters.setSenha('')
        localStorage.removeItem('userEmail')
        localStorage.removeItem('userPassword')
    }

    useEffect(() => {
        localStorage.removeItem('token')
        setters.setSigned(false)
        const email = localStorage.getItem('userEmail')
        const password = localStorage.getItem('userPassword')
        if (email && password) {
            setters.setEmail(email)
            setters.setSenha(password)
            setRemainSigned(true)
        }
    }, [])

    useEffect(() => {
        if (remainSigned) {
            localStorage.getItem('userEmail')
            localStorage.getItem('userPassword')
        }
    }, [states.email, states.senha])

    const getInputClass = (hasError) => {
        const base = "w-full px-4 py-3 rounded-xl border text-sm transition-all duration-200 outline-none"
        if (states.isLoading) return `${base} border-gray-200 bg-gray-100 placeholder-gray-300 text-gray-400 cursor-not-allowed`
        if (hasError) return `${base} border-red-300 bg-red-50 placeholder-red-300 text-red-700 focus:border-red-400 focus:ring-2 focus:ring-red-200`
        return `${base} border-gray-200 bg-white placeholder-gray-400 text-gray-800 focus:border-brand-yellow focus:ring-2 focus:ring-brand-yellow/30`
    }

    return (
        <div className="min-h-screen flex">
            <div className="relative hidden lg:flex lg:w-1/2 xl:w-3/5 flex-col justify-end overflow-hidden bg-gray-950">
                <img
                    className="absolute inset-0 h-full w-full object-cover opacity-30"
                    src={jsonConfig.urlReact + '/background.jpeg'}
                    alt=""
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/50 to-transparent" />
                <div className="relative z-10 p-12 space-y-3">
                    <div className="w-10 h-1 rounded-full bg-brand-yellow" />
                    <h2 className="text-4xl font-bold text-white leading-tight">
                        Portal de gestão<br />Matriz MG
                    </h2>
                    <p className="text-gray-500 text-sm pt-2">
                        © {new Date().getFullYear()} MATRIZ MG — Todos os direitos reservados.
                    </p>
                </div>
            </div>

            <div className="flex flex-1 flex-col justify-center items-center px-8 py-12 bg-white">
                <div className="w-full max-w-sm">
                    <div className="mb-10 flex flex-col items-start gap-6">
                        <img className="h-14 w-auto" src={`${jsonConfig.urlReact}/logo.png`} alt="Matriz Mg Logo" />
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">
                                {perdeuSenha ? 'Recuperar senha' : 'Bem-vindo de volta'}
                            </h1>
                            <p className="mt-1 text-sm text-gray-400">
                                {perdeuSenha
                                    ? 'Informe seu e-mail para receber o link de recuperação.'
                                    : 'Acesse com suas credenciais.'}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-5">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                                E-mail
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                disabled={states.isLoading}
                                value={states.email}
                                onChange={(e) => {
                                    const v = e.target.value.trim()
                                    setters.setEmail(v)
                                    if (v === '') { setErrorEmail(true); setMsgErrorEmail('O campo email é obrigatório') }
                                    else { setErrorEmail(false) }
                                }}
                                onKeyDown={(e) => e.key === 'Enter' && actionLogin()}
                                autoComplete="email"
                                placeholder="seu@email.com"
                                className={getInputClass(errorEmail)}
                            />
                            {errorEmail && <p className="text-red-500 text-xs mt-1.5">{msgErrorEmail}</p>}
                        </div>

                        {!perdeuSenha && (
                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1.5">
                                    Senha
                                </label>
                                <div className={`${getInputClass(errorSenha)} flex items-center gap-2 !py-0 !px-0`}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        name="password"
                                        disabled={states.isLoading}
                                        value={states.senha}
                                        onChange={(e) => {
                                            const v = e.target.value.trim()
                                            setters.setSenha(v)
                                            setErrorSenha(v === '')
                                        }}
                                        onKeyDown={(e) => e.key === 'Enter' && actionLogin()}
                                        autoComplete="current-password"
                                        placeholder="Sua senha"
                                        className="flex-1 bg-transparent px-4 py-3 text-sm outline-none input-no-focus"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="pr-4 text-gray-400 hover:text-gray-700 transition-colors"
                                    >
                                        {showPassword
                                            ? <EyeIcon className="h-5 w-5" aria-hidden="true" />
                                            : <EyeSlashIcon className="h-5 w-5" aria-hidden="true" />}
                                    </button>
                                </div>
                                {errorSenha && <p className="text-red-500 text-xs mt-1.5">O campo senha é obrigatório</p>}

                                <div className="flex items-center justify-between mt-3">
                                    <button
                                        type="button"
                                        onClick={perdeuSenhaAction}
                                        disabled={states.isLoading}
                                        className="text-sm font-medium text-gray-500 hover:text-gray-800 disabled:opacity-50 transition-colors"
                                    >
                                        Esqueceu sua senha?
                                    </button>
                                    <label className="flex items-center gap-2 cursor-pointer select-none">
                                        <input
                                            id="remember-me"
                                            name="remember-me"
                                            type="checkbox"
                                            checked={remainSigned}
                                            onChange={() => remindSignedAction(!remainSigned)}
                                            className="h-4 w-4 rounded border-gray-300 accent-brand-yellow"
                                        />
                                        <span className="text-sm text-gray-600">Lembrar-me</span>
                                    </label>
                                </div>
                            </div>
                        )}

                        <div className="pt-1 space-y-3">
                            <button
                                onClick={actionLogin}
                                type="button"
                                disabled={states.isLoading}
                                className="w-full flex justify-center items-center gap-3 py-3 px-4 rounded-xl text-sm font-bold text-gray-900 bg-brand-yellow hover:bg-brand-yellow-dark disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-yellow"
                            >
                                {states.isLoading && (
                                    <span className="h-4 w-4 rounded-full border-2 border-gray-900/20 border-t-gray-900 animate-spin" />
                                )}
                                {perdeuSenha ? 'Enviar link de recuperação' : 'Entrar'}
                            </button>

                            {perdeuSenha && (
                                <button
                                    onClick={voltarLogin}
                                    type="button"
                                    disabled={states.isLoading}
                                    className="w-full flex justify-center items-center py-3 px-4 rounded-xl text-sm font-medium text-gray-600 border border-gray-200 hover:bg-gray-50 disabled:opacity-50 transition-all duration-200"
                                >
                                    Voltar para o login
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="mt-10 flex justify-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login
